module.exports = __webpack_public_path__ + "site/img/67.efec6cca.jpg";